<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-16">
            <md-field>
              <label>Vendor Pan</label>
              <md-input type="text" v-model="vendorPan" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-16">
            <md-field>
              <label>Assessment Year</label>
              <md-input
                type="text"
                v-model="assessmentYear.text"
                readonly
                @click="openValueSetModal('ASSESSMENT_YEAR')"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <div style="margin-top:10px ; display: flex; gap: 1rem;">
              <md-button
                class="md-raised md-success"
                @click="getVendorTdsCertificate()"
                >Search</md-button
              >
              <md-button
                class="md-raised md-info search-btn"
                @click="clearFilter()"
                >Clear</md-button
              >
            </div>
          </div>
        </div>
      </md-card>
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-content>
          <div class="md-layout-item">
            <b-table
              striped
              bordered
              hover
              outlined
              sticky-header
              :items="tdsCertificateData"
              :fields="tdsCertificateFields"
              show-empty
              md-height
            >
              <template #cell(openkm_uuid)="data">
                <md-button
                  @click="getOpenKmAuthenticate(data.item.openkm_uuid ,data.item.file_name)"
                >
                  Download
                </md-button>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <valueSetModal
      v-if="showValueSetModal"
      @selectedvalueSet="selectedvalueSet"
      @closeValueSetModal="closeValueSetModal"
    ></valueSetModal>
  </div>
</template>

<script>
import commonHelperUtility from "../../../../utility/common.helper.utility";
import appStrings from "../../../../utility/string.utility";
import URL_UTILITY from "../../../../utility/url.utility";
export default {
  components: {},
  name: "TDSCertificate",
  watch: {
    currentPage: function() {
      this.getVendorTdsCertificate();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getVendorTdsCertificate();
    },
  },

  data() {
    return {
      perPage: commonHelperUtility.perPageRecord,
      pageOptions: commonHelperUtility.getPageOption(),
      currentPage: 1,
      totalRows: null,
      tdsCertificateData: [],
      tdsCertificateFields: [
        {
          key: "le_name",
        },
        {
          key: "tan_no",
        },
        {
          key: "assessment_year",
        },
        {
          key: "certificate_no",
        },
        {
          key: "from_date",
        },
        {
          key: "to_date",
        },
        {
          key: "base_amount",
        },
        {
          key: "tds_amount",
          label: "TDS Amount",
        },
        {
          key: "openkm_uuid",
          label: "Download",
        },
      ],
      lastCertificateDate: null,
      toDate: null,
      fromDate: null,
      assessmentYear: {
        text: null,
        value: null,
      },
      downloadDocUrl: URL_UTILITY.getDocumentDownloadUrl,
      vendorId: null,
      leId: null,
      openKmAuth: null,
      vendorPan: null,
      showValueSetModal: false,
      vsetCode: null,
    };
  },
  mounted() {
    this.leId = sessionStorage.getItem("leId")
      ? sessionStorage.getItem("leId")
      : "All";
    this.getVendor();
    setTimeout(() => {
      this.getVendorTdsCertificate();
    }, 500);
  },
  methods: {
    getVendor() {
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("vendor/getVendor")
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            const result = resp.data.data;
            this.gridDataVendor = result;
            this.vendor = result[0].vendor;
            this.vendorId = result[0].vendor_id;
          }
        })
        .catch(() => {
          this.$store.dispatch("shared/setLoader", false);
        });
    },
    // getLastUploadTdsCertificate() {
    //   this.$store.dispatch("shared/setLoader", true);
    //   this.$store
    //     .dispatch("vendor/getLastUploadTdsCertificate")
    //     .then((resp) => {
    //       this.$store.dispatch("shared/setLoader", false);
    //       if (resp.status === 200) {
    //         this.lastCertificateDate = resp.data.data;
    //       }
    //     });
    // },
    getVendorTdsCertificate() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        assessment_year: this.assessmentYear.value,
        vendor_id: this.vendorId,
        le_id: this.leId,
      };
      this.$store.dispatch("shared/setLoader", true);
      this.$store
        .dispatch("vendor/getVendorTdsCertificate", payload)
        .then((resp) => {
          this.$store.dispatch("shared/setLoader", false);
          if (resp.status === 200) {
            this.tdsCertificateData = resp.data.data.page;
            this.vendorPan = this.tdsCertificateData[0].vendor_pan_no;
            this.totalRows =resp.data.data.total_elements;
          }
        });
    },
    clearFilter() {
      this.assessmentYear = {
        text: null,
        value: null,
      };
      this.fromDate = null;
      this.toDate = null;
      this.tdsCertificateData = null;
      this.getVendorTdsCertificate();
    },
    showHideTdsCertificateModal(flag) {
      this.showTdsCertificateModal = flag;
    },
    getOpenKmAuthenticate(uuid , fileName) {
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              this.downloadDocument(uuid, fileName);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    downloadDocument(uuid, fileName) {
      const url =
        this.downloadDocUrl +
        "/download/tds/" +
        uuid +
        "?token=" +
        this.openKmAuth;
      commonHelperUtility.downloadFile(url, fileName);
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null,
        };
        this.eventBus.$emit("valueSetCode", vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.ASSESSMENT_YEAR) {
        this.assessmentYear.text = item.value_meaning;
        this.assessmentYear.value = item.value_code;
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
  },
};
</script>
